import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AppRoute } from '@app/core/enums/app-route.enum';
import { UserProfileService } from '@app/modules/user-profile/services/user-profile.service';
import { IUser } from '@common/models/IUser';
import { from, map, Observable, switchMap, take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreferredLandingGuard  {
   constructor(private readonly router: Router, private readonly userService: UserProfileService, private readonly msalService: MsalService,){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
     return from(this.msalService.handleRedirectObservable()).pipe(
          switchMap(() => this.userService.getMe()), 
          take(1),
          tap((user: IUser) => {
            if (user?.preferredLandingPage) {
              this.router.navigateByUrl(user.preferredLandingPage);
            } else {
              this.router.navigateByUrl(AppRoute.Companies);
            }
          }),
          map(() => null)
        );
  }
  
}
